import styled from 'styled-components';
import { Typography } from '@mui/material';
import { localizeDate } from '../../../utils/datetime';
import { Flex } from '../../Flex';
import { QuotaScope } from '../types';
import {
  fontSize,
  lineHeight,
  radius,
  shadow,
  space,
} from '../../../style/utils';

const formatReset = (
  scope: QuotaScope,
  resetsAt?: string | null,
): string | null => {
  if (!resetsAt) return null;
  const resetDate = localizeDate(resetsAt);
  if (!resetDate.isValid()) return null;
  return scope === 'monthly' ? resetDate.format('LL') : resetDate.format('LT');
};

export const buildQuotaMessage = (
  scope: QuotaScope,
  resetsAt?: string | null,
): string => {
  const resetLabel = formatReset(scope, resetsAt);
  if (scope === 'monthly') {
    return resetLabel
      ? `Monthly token limit used. Resets on ${resetLabel}.`
      : 'Monthly token limit used.';
  }
  return resetLabel
    ? `Daily token limit used. Resumes at ${resetLabel}.`
    : 'Daily token limit used.';
};

const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  align-self: center;
  width: calc(100% - 14px);
  border-radius: ${radius('md', 'md', 0, 0)};
  background: ${({ theme }) => theme.palette.status.warning.bgStrong};
  box-shadow: ${shadow('sheet')};
`;

const Message = styled(Typography).attrs({ component: 'div' as const })`
  font-size: ${fontSize('sm')};
  line-height: ${lineHeight('sm')};
  letter-spacing: 0.12px;
  color: ${({ theme }) => theme.palette.content.secondary};
  text-align: center;
  width: 100%;
  padding: ${space('xxs', 'xxl')};
  box-sizing: border-box;
  margin: 0;
`;

type Props = {
  scope?: QuotaScope;
  resetsAt?: string | null;
};

const QuotaBanner = ({ scope = 'daily', resetsAt }: Props) => (
  <Wrapper>
    <Message>{buildQuotaMessage(scope, resetsAt)}</Message>
  </Wrapper>
);

export default QuotaBanner;
